/**
 * @generated SignedSource<<2ed51ad63495fc621ca40fff6b35c3b4>>
 * @relayHash 8ae3c137953b4e3e0049335ffb3be3c9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 11b6405c2dc7d6e3b438f79bcf5a1758786eff77074374eddefc0a13723f0762

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraFavouriteType = "BOARD" | "DASHBOARD" | "FILTER" | "JPD_COLLECTION" | "PLAN" | "PROJECT" | "QUEUE" | "%future added value";
export type SortDirection = "ASC" | "DESC" | "%future added value";
export type JiraFavouriteFilter = {
  includeArchivedProjects?: boolean | null;
  keyword?: string | null;
  sort?: JiraFavouriteSortInput | null;
  type?: JiraFavouriteType | null;
  types?: ReadonlyArray<JiraFavouriteType> | null;
};
export type JiraFavouriteSortInput = {
  order: SortDirection;
};
export type useStarredItemsQuery$variables = {
  cloudId: string;
  count: number;
  filter: JiraFavouriteFilter;
};
export type useStarredItemsQuery$data = {
  readonly jira: {
    readonly allFavourites: {
      readonly pageInfo: {
        readonly startCursor: string | null;
      };
    } | null;
  };
  readonly " $fragmentSpreads": FragmentRefs<"useStarredItems">;
};
export type useStarredItemsQuery = {
  response: useStarredItemsQuery$data;
  variables: useStarredItemsQuery$variables;
};
({
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabled": isJpdRoadmapsRecentsEnabled_provider
} as {
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabled: {
    readonly get: () => boolean;
  };
});

import isJpdRoadmapsRecentsEnabled_provider from '@jira/platform__graphql-relay-provider/src/isJpdRoadmapsRecentsEnabled';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "count"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v3 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v4 = {
  "kind": "Variable",
  "name": "filter",
  "variableName": "filter"
},
v5 = [
  (v3/*: any*/),
  (v4/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v6 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "startCursor"
    }
  ]
},
v7 = [
  (v3/*: any*/),
  (v4/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  }
],
v8 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v9 = {
  "kind": "ScalarField",
  "name": "id"
},
v10 = {
  "kind": "ScalarField",
  "name": "lastViewedTimestamp"
},
v11 = {
  "kind": "InlineFragment",
  "selections": [
    (v9/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v12 = {
  "kind": "LinkedField",
  "name": "defaultNavigationItem",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "url"
        }
      ],
      "type": "JiraNavigationItem",
      "abstractKey": "__isJiraNavigationItem"
    },
    (v11/*: any*/)
  ]
},
v13 = [
  (v9/*: any*/),
  (v10/*: any*/),
  {
    "alias": "filterTitle",
    "kind": "ScalarField",
    "name": "name"
  },
  {
    "kind": "ScalarField",
    "name": "filterUrl"
  },
  {
    "kind": "ScalarField",
    "name": "filterId"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useStarredItemsQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "alias": "allFavourites",
              "args": (v5/*: any*/),
              "concreteType": "JiraFavouriteConnection",
              "kind": "LinkedField",
              "name": "favourites",
              "plural": false,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": (v6/*: any*/),
                  "action": "THROW"
                }
              ]
            }
          ]
        },
        "action": "THROW"
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          }
        ],
        "kind": "FragmentSpread",
        "name": "useStarredItems"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabled"
      }
    ],
    "kind": "Operation",
    "name": "useStarredItemsQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "alias": "allFavourites",
            "args": (v5/*: any*/),
            "concreteType": "JiraFavouriteConnection",
            "kind": "LinkedField",
            "name": "favourites",
            "plural": false,
            "selections": [
              (v6/*: any*/)
            ]
          },
          {
            "alias": "starredItems",
            "args": (v7/*: any*/),
            "concreteType": "JiraFavouriteConnection",
            "kind": "LinkedField",
            "name": "favourites",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraFavouriteEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v9/*: any*/),
                          (v10/*: any*/),
                          {
                            "alias": "projectTitle",
                            "kind": "ScalarField",
                            "name": "name"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "key"
                          },
                          (v12/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "description"
                          },
                          {
                            "concreteType": "JiraAvatar",
                            "kind": "LinkedField",
                            "name": "avatar",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "large"
                              }
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "projectId"
                          }
                        ],
                        "type": "JiraProject"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v9/*: any*/),
                          (v10/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "planId"
                          },
                          {
                            "concreteType": "JiraScenario",
                            "kind": "LinkedField",
                            "name": "scenario",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "scenarioId"
                              },
                              (v9/*: any*/)
                            ]
                          },
                          {
                            "alias": "planTitle",
                            "kind": "ScalarField",
                            "name": "title"
                          }
                        ],
                        "type": "JiraPlan"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v9/*: any*/),
                          (v10/*: any*/),
                          {
                            "alias": "boardTitle",
                            "kind": "ScalarField",
                            "name": "name"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "boardId"
                          },
                          (v12/*: any*/)
                        ],
                        "type": "JiraBoard"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v9/*: any*/),
                          (v10/*: any*/),
                          {
                            "alias": "dashboardTitle",
                            "kind": "ScalarField",
                            "name": "title"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "dashboardUrl"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "dashboardId"
                          }
                        ],
                        "type": "JiraDashboard"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v13/*: any*/),
                        "type": "JiraSystemFilter"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v13/*: any*/),
                        "type": "JiraCustomFilter"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v9/*: any*/),
                          (v10/*: any*/),
                          {
                            "alias": "queueTitle",
                            "kind": "ScalarField",
                            "name": "title"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "queueUrl"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "queueId"
                          }
                        ],
                        "type": "JiraServiceManagementQueue"
                      },
                      {
                        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabled",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v9/*: any*/),
                              (v10/*: any*/),
                              {
                                "alias": "collectionTitle",
                                "kind": "ScalarField",
                                "name": "title"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "collectionUrl"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "collectionId"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "emoji"
                              }
                            ],
                            "type": "JiraProductDiscoveryCollection"
                          }
                        ]
                      },
                      (v11/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "cursor"
                  }
                ]
              },
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "endCursor"
                  }
                ]
              }
            ]
          },
          {
            "alias": "starredItems",
            "args": (v7/*: any*/),
            "filters": [
              "cloudId",
              "filter"
            ],
            "handle": "connection",
            "key": "useStarredItemsPaged_starredItems",
            "kind": "LinkedHandle",
            "name": "favourites"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "11b6405c2dc7d6e3b438f79bcf5a1758786eff77074374eddefc0a13723f0762",
    "metadata": {},
    "name": "useStarredItemsQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabled": isJpdRoadmapsRecentsEnabled_provider
    }
  }
};
})();

(node as any).hash = "a990bf62548a878e271579864264b597";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
